// extracted by mini-css-extract-plugin
export default {"DAloaderIcon":"Loader_DAloaderIcon__QKf+q"};